import lazyLoading from './lazyLoading'

export default {
  name: 'Products',
  path: '/products',
  meta: {
    auth: true,
    icon: 'fa-cubes',
    link: 'products/index.vue'
  },
  component: lazyLoading('products', true)
  // children : []
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/products.js